import { render, staticRenderFns } from "./MypagePointItemParts.vue?vue&type=template&id=46ab887c&scoped=true"
import script from "./MypagePointItemParts.vue?vue&type=script&lang=ts"
export * from "./MypagePointItemParts.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointItemParts.vue?vue&type=style&index=0&id=46ab887c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab887c",
  null
  
)

export default component.exports